import Link from "next/link";
import { useEffect, useRef } from "react";
import Button from "../../component/commons/button/Button";
import { CardAuctionDetail } from "../../component/commons/card/Card";
import { ArrowRight2Icon } from "../../component/commons/icon/SvgIcon";
import MapRegion from "../../component/plugins/map/MapRegion";
import { advgList } from "../../helpers/MenuList";
import { DetailRegionProps } from "../../helpers/types/getTypes";

const RegionDetail = ({
  mode,
  data,
  type,
}: {
  mode: string;
  data: DetailRegionProps;
  type: "city" | "state";
}) => {
  const recent = useRef<HTMLDivElement | null>(null);
  const onScroll = (scrollOffset: number) => {
    if (recent.current) {
      recent.current.scrollLeft += scrollOffset;
    }
  };

  useEffect(() => {
    recent.current?.addEventListener("scroll", () => {});

    return () => recent.current?.removeEventListener("scroll", () => {});
  }, []);

  return (
    <>
      <section className="mt-6 lg:mt-[5.75rem] mx-4.5 lg:mx-8 xl:mx-16 flex flex-col-reverse lg:flex-row lg:space-x-5">
        <div className="mt-3.5 lg:mt-0 lg:w-7/12 h-[31.25rem] lg:h-[32.625rem] focus:!outline-none focus-visible:!outline-none">
          <MapRegion mode={mode} data={data.facilities} />
        </div>
        <div className="flex flex-col lg:w-5/12">
          <div className="text-neutral-900 font-bold text-title3 leading-[2.125rem] md:text-4xl md:leading-[3.5rem] lg:w-[33.438rem]">
            Find Storage Unit Auctions Happening In {data[type].name}
          </div>
          <div className="mt-3 lg:mt-1.5 text-neutral-700 text-small-normal leading-6 md:text-large-normal md:leading-7 lg:w-[33.438rem]">
            Subscribe to get access to storage unit auctions happening in across
            the state of {data[type].name}
          </div>
          <div className="mt-3 md:mt-7 font-bold text-neutral-900 text-large-normal md:text-title3">
            What you get when you signup...
          </div>
          <div className="mt-3 text-small-normal leading-6 md:text-regular-normal text-neutral-900 pr-10">
            Instant Access to 100,000+ Monthly Storage Auctions
          </div>
          <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-y-6 lg:gap-y-[2.125rem] lg:gap-x-6">
            {advgList.map((e, key: number) => (
              <div key={key} className="flex flex-row items-center space-x-3">
                <div
                  className={`min-w-[2.75rem] md:min-w-[3.25rem] rounded-[0.875rem] p-2.5 md:p-3.5 w-fit ${e.className}`}
                >
                  <e.Icon />
                </div>
                <div className="font-bold lg:font-medium text-neutral-900 text-large-none lg:text-large-normal">
                  {e.title}
                </div>
              </div>
            ))}
          </div>
          <div className="mt-6 lg:mt-[2.125rem] grid grid-cols-1 lg:grid-cols-2 gap-y-6 lg:gap-y-[2.125rem] lg:gap-x-6">
            <div>
              <Link
                href={`/facility/list?${
                  type === "city"
                    ? `filter_state=${data[type].state.id}&state=${data[type].state.name}&filter_city=${data[type].id}&city=${data[type].name}`
                    : `filter_state=${data[type].id}&state=${data[type].name}`
                }`}
              >
                <a>
                  <Button
                    size="lg"
                    className="!rounded-full w-full !bg-primary-50 !text-primary-500 hover:!bg-primary-100 hover-anime"
                  >
                    Browse Facilities
                  </Button>
                </a>
              </Link>
            </div>
            <div>
              <Link href={`${process.env.NEXT_PUBLIC_BUYER_URL}/b/sign-up`}>
                <a target="_blank">
                  <Button
                    size="lg"
                    className="!rounded-full w-full hover-anime"
                  >
                    Sign Up
                  </Button>
                </a>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {data.recent_adds.length > 0 && (
        <section className="mt-12  mx-4.5 lg:mx-8 xl:mx-16">
          <div className="font-bold text-neutral-900 text-title3 leading-[2.125rem] lg:text-4xl lg:leading-[3.5rem] md:block hidden">
            Last 10 Storage Unit Auctions Added in {data[type].name}
          </div>
          <div className="font-bold text-neutral-900 text-title3 leading-[2.125rem] md:hidden">
            Last 10 Auctions Added
          </div>
          <div className="mt-7 relative group">
            <div
              className="absolute inset-y-3 right-0 opacity-0 group-hover:opacity-100 hover-anime cursor-pointer"
              onClick={() => onScroll(200)}
            >
              <div className="bg-white rounded-full p-3 shadow-lv3">
                <ArrowRight2Icon />
              </div>
            </div>
            <div
              className="absolute inset-y-3 left-0 opacity-0 group-hover:opacity-100 hover-anime cursor-pointer"
              onClick={() => onScroll(-200)}
            >
              <div className="bg-white rounded-full p-3 shadow-lv3">
                <ArrowRight2Icon className="rotate-180" />
              </div>
            </div>
            <div
              ref={recent}
              className="overflow-x-auto sidebar flex flex-row items-center space-x-7 scroll-smooth"
            >
              {data.recent_adds.map((e, key: number) => (
                <CardAuctionDetail data={e} key={key} />
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default RegionDetail;
